if (typeof ModalDialog !== "undefined" && !customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener("click", (event) => {
          const thumb = event.target.closest("li.thumbnail-list__item[data-target]");
          const sliderBtn = event.target.closest(".fp-product-modal__slider-button");
          if (!thumb && !sliderBtn) return;
          this.resetZoom();
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute("data-media-id");
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove("active");
        });
        this.querySelectorAll(`[data-target]:not([data-target="${mediaId}"])`).forEach((element) => {
          element.querySelector(".thumbnail").removeAttribute("aria-current");
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        this.resetZoom();
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        const activeMediaThumbnail = this.querySelector(`[data-target="${mediaId}"]`);
        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();
        activeMediaThumbnail.querySelector(".thumbnail").ariaCurrent = true;
        activeMediaThumbnail.scrollIntoView({ block: "nearest", inline: "nearest" });

        const container = this.querySelector('[role="region"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == "DEFERRED-MEDIA" && activeMediaContent) activeMedia.loadContent();
      }
      resetZoom() {
        this.querySelectorAll("pinch-zoom").forEach((pinchZoom) => {
          pinchZoom.reset();
        });
      }
    },
  );
} else if (typeof ModalDialog === "undefined") {
  console.warn("ModalDialog base class is not defined before product-modal.js loaded.");
}
